var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogCreateProduct',{ref:"form",attrs:{"customersList":_vm.customersList,"productTypesList":_vm.productTypesData},on:{"on-done":function($event){return _vm.$emit('on-done')}}})}
var staticRenderFns = []

export { render, staticRenderFns }